module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg19-1a3d156abdd2c80ed7db716b1b736ba5.jpg";